document.addEventListener("DOMContentLoaded", ()=> {
                          /*------- ---------- --------*/
                          /*------- ---------- --------*/
                          /*------- ANIMATIONS --------*/
                          /*------- ---------- --------*/
                          /*------- ---------- --------*/
                          const shapes = document.querySelectorAll(".shapes-animation");
						  const backgroundShapes = document.querySelectorAll(".heartbeat-animation");
const testimonialsSection = document.querySelectorAll(".section-testimonials--home");
const yippies = document.querySelectorAll(".heartbeat");


observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      if( entry.target.classList.contains("shapes-animation")){
      entry.target.classList.add("shapes-animation-in-view")
      }
      
      if( entry.target.classList.contains("heartbeat-animation")){
         entry.target.classList.add("heartbeat-animation-in-view")
      }
      
      if( entry.target.classList.contains("heartbeat")){
         entry.target.classList.add("heartbeat-in-view")
      }
      //move background positioning as you scroll (parallax)
      if( entry.target.classList.contains("section-testimonials--home")){
        const top = window.scrollY
        document.addEventListener("scroll", ()=>{                   
                     let percentageScrolled =  top /  window.scrollY;
        entry.target.style.backgroundPositionX = `${(percentageScrolled * 100) - 100}%`
        
                                      })
      }
      
    } else {
       if( entry.target.classList.contains("shapes-animation")){
      entry.target.classList.remove("shapes-animation-in-view")
       }
      
      if( entry.target.classList.contains("heartbeat-animation")){
         entry.target.classList.remove("heartbeat-animation-in-view")
      }

if( entry.target.classList.contains("heartbeat")){
         entry.target.classList.remove("heartbeat-in-view")
      }
 
    }
  });
});

shapes.forEach(shape => {
  observer.observe(shape);
});

backgroundShapes.forEach(shape => {
  observer.observe(shape);
});

testimonialsSection.forEach(section => {
  observer.observe(section);
});


yippies.forEach(yippie => {
  observer.observe(yippie);
});





})